<swiper [config]="config">
  <div *ngFor="let project of projects">
    <unh-project-item [project]="project">
    </unh-project-item>
  </div>
</swiper>